import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, useCheckboxGroup } from '@chakra-ui/react';
import { useEffect, useMemo } from 'react';
import { BlockErrors } from '@/components';
import { useResolveValue } from '@/hooks';
import { filterBlockAnswers, getInputBlockAnswer } from '@/utils';
import { BlockLayout } from '../fragments/BlockLayout';
import { Checkbox } from '../fragments/Checkbox';
export const Checkboxes = ({ answerKey, block, defaultValue, errors = [], onChange }) => {
    const { answer_filters = [], id, key, layout, max, typed_answers } = block;
    const { getCheckboxProps, setValue, value: checkedList } = useCheckboxGroup({ defaultValue: [] });
    const [resolver] = useResolveValue();
    const resolved = useMemo(() => {
        const answerKeys = resolver.resolveAnswerFilter(answer_filters);
        const filters = filterBlockAnswers(typed_answers.answers, answerKeys, defaultValue);
        const answersList = filters.answersFiltered.map((a, order) => {
            return Object.assign(Object.assign({}, a), { label: resolver.resolveString(a.label), order });
        });
        return {
            answersList
        };
    }, [block, defaultValue, resolver]);
    useEffect(() => {
        if (!Array.isArray(answerKey) || answerKey.length === 0) {
            setValue([]);
            return;
        }
        const mapped = answerKey
            .map((k) => {
            const match = resolved.answersList.find((a) => a.key === k);
            return match ? match.id : null;
        })
            .filter((v) => v !== null);
        const current = Array.isArray(checkedList) ? checkedList : [];
        const same = mapped.length === current.length && mapped.every((v, i) => v === current[i]);
        if (!same)
            setValue(mapped);
    }, [answerKey, resolved.answersList]);
    const isDisabled = (val) => !checkedList.includes(val) && checkedList.length >= max;
    const handleChange = (answer) => {
        const newAnswer = getInputBlockAnswer(typed_answers.type, answer, key);
        onChange(newAnswer, {
            multipleAnswer: true,
            order: answer.order
        });
    };
    return (_jsx(BlockErrors, Object.assign({ errors: errors }, { children: _jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(Flex, Object.assign({ "data-test": id, direction: 'column', gridGap: '4' }, { children: resolved.answersList.map((answer) => {
                    return (_jsx(Checkbox, Object.assign({ answer: answer, answerChange: handleChange, isDisabled: isDisabled(answer.id) }, getCheckboxProps({ value: answer.id })), answer.id));
                }) })) })) })));
};
